import { Defaults } from 'es-decorators'
import { Items } from 'es6/collections/items'
import { View } from 'es6/components/view'
import { CUSTOM_QTY_UNITS_ATTR_ID } from 'es6/constants'
import 'es6/libs/owl-carousel'
import { generateUniqId } from 'helpers/template-helper'
import { entryScriptName } from 'init/entry-script-name'
import $ from 'init/jquery'
import isFunction from 'lodash/isFunction'
import isEqual from 'lodash/isEqual'
import some from 'lodash/some'
import toArray from 'lodash/toArray'
import { currentCurrency } from 'init/current-currency'
import { RecommendationsItemView } from './recommendations-item-view'
import { isMobile } from 'init/is-mobile'
import { ItemInViewPortMixin } from 'es6/mixins/item-in-viewport-mixin'

/**
 * Рекомендованные товары
 */
@Defaults({
  el: '.recommendation-list',
  itemSelector: '.recommendations-item',
  slideItems: 5,
  slideBy: 5,
  isCart: false,
  carouselOptions: {},
  additionalOptions: [
    'withoutCarousel',
    'itemSelector',
    'algo',
    'items',
    'isNarrowCarousel',
    'carouselOptions',
    'mainWindow',
    'isCart',
  ],
  recommendationsLastQuery: {},
  ...ItemInViewPortMixin,
})
export class RecommendationsCarouselView extends View {
  /** @inheritDoc */
  beforeRun () {
    // корзина
    if (window.location.pathname.search('/cart/') > -1) {
      this.isCart = true
      this.$el.closest('section')
        .removeClass('wide')
        .addClass('main')
      return
    }

    // просмотр заказа
    if (window.location.pathname.search(new RegExp(/order\/\d+/)) > -1) {
      this.$el.closest('section')
        .removeClass('wide')
        .addClass('main')
      return
    }

    // подраздел каталога
    if ($('.catalog-holder')) {
      this.$('section')
        .addClass('l-recommended')
      return
    }

    // корневой раздел каталога
    if ($('.category_page')) {
      this.$('section')
        .removeClass('wide')

      this.slideItems = 8
      this.slideBy = 8
    }
  }

  /**
   * @inheritDoc
   */
  run () {
    this.countItems = (this.$el.children() ? this.$el.children().length : 0)
      || (this.items ? this.items.length : 0)
    this.sids = []
    this.$recommendationsItems = this.$(this.itemSelector)
    this.elementsLength = this.$recommendationsItems.length
    this.$recommendationsItems.each((index, item) => {
      const sid = $(item).data('sid')
      if (!this.cart.findWhere({ sid })) {
        this.sids.push(sid)
      }
    })
    if (this.countItems || this.sids.length) {
      this.listenToOnce(this, 'got-items-info', this.createItemViews)
      this.getItemsWithCartItem(this.sids)
    }
  }

  /**
   * Создает представления для переданных товаров
   * @param {Items} items - коллекция товаров
   * @param {Array} cartItems - массив товаров в корзине
   */
  createItemViews (items, cartItems) {
    if (cartItems.length) {
      // Устанавливаем флаг для предотвращения событий обновления корзины
      this.cart.isSyncing = true
      this.cart.set(cartItems, { remove: false, silent: true })
    }
    // В каждую вью передаем полученный объект со свойствами товара
    this.childViews.recommendationsItemViews = []
    this.$recommendationsItems.each((index, itemEl) => {
      const sid = this.sids[index]
      const item = items.findWhere({ sid })
      if (item) {
        this.childViews.recommendationsItemViews.push(new RecommendationsItemView({
          el: this.$(`.recommendations-item[data-sid=${sid}]`),
          sid,
          model: item,
          cart: this.cart,
          settlement: this.settlement,
          user: this.user,
          algo: this.algo,
          isCart: this.isCart,
        }))
      } else {
        this.$(itemEl).remove()
      }
    })
    if (!this.withoutCarousel && !isMobile) {
      this.drawCarousel()
    }
    this.cart.isSyncing = false
    if (isFunction(this.onSuccessItemsRequest)) {
      this.onSuccessItemsRequest()
    }
  }

  /**
   * Запрос товаров с последними sid
   * @param {Array} lastSids Идентификаторы товаров.
   */
  makeRequest (lastSids) {
    this.listenToOnce(this, 'item:success', this.prepareItems)
    $.ajax({
      url: `${entryScriptName}/api/v3/item/?sid=${lastSids.join(',')}&currency=${currentCurrency.name}&expand=cart_item`,
      type: 'GET',
      success: data => {
        this.trigger('item:success', data, lastSids)
      },
    })
    this.recommendationsLastQuery.sids = lastSids
    this.recommendationsLastQuery.response = null
  }

  /**
   * Подготовка товаров
   * @param {Object} data Данные о товарах.
   * @param {Array} lastSids Идентификаторы товаров.
   */
  prepareItems (data, lastSids) {
    const cartItems = []
    const itemsFiltered = toArray(data.items).filter(item => {
      return !item.is_deleted && !item.is_disabled && (item.isEnough || item.balance > 0)
    })
    itemsFiltered.map(item => {
      if (
        some(item.attrs, { attr_id: CUSTOM_QTY_UNITS_ATTR_ID, boolean_value: 1 })
        && item.nestedUnit
        && item.in_set > 0
        && item.in_set !== 1
      ) {
        item.has_custom_qty_units = true
      }
      if (item.cart_item) {
        let cart_item = item.cart_item
        if (typeof item.cart_item === 'string') {
          try {
            cart_item = JSON.parse(decodeURIComponent(item.cart_item))
          } catch (err) {
            err.message = 'Cannot parse JSON when item.cart_item is' + item.cart_item
            if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
              Raven.captureException(err)
              item.cart_item = false
            } else {
              throw err
            }
          }
        }
        cartItems.push(cart_item)
        item.cart_item = cart_item
      }
      return item
    })
    this.trigger('got-items-info', new Items(itemsFiltered), cartItems)

    // Сохраняем последний запрос и результат
    this.recommendationsLastQuery = {
      sids: lastSids,
      response: data,
    }
  }

  /**
   * Получаем данные рекомендованных товаров
   * @param {Array} sids Идентификаторы товаров.
   */
  getItemsWithCartItem (sids) {
    const itemSids = this.items ? this.items.map(item => item.sid) : null
    if (Array.isArray(itemSids) && isEqual(sids, itemSids)) {
      this.prepareItems({ items: this.items }, itemSids)
    } else {
      if (!isEqual(this.recommendationsLastQuery.sids, sids) || !this.recommendationsLastQuery.response) {
        /*
         * Если текущий sids отличается от предыдущего делаем запрос и завершаем работу.
         * Если это аналоги отсутствующего товара, делаем запрос всегда.
         */
        this.makeRequest(sids)
      } else {
        // Если не отличается от предыдущего и есть ответ
        if (this.recommendationsLastQuery.response) {
          this.prepareItems(this.recommendationsLastQuery.response)
        }
        // Если список не отличается, перерисовываем карусель (для случая смены валюты)
        if (!isMobile) {
          this.drawCarousel()
        }
      }
    }
  }

  /**
   * Отрисовка карусели
   */
  drawCarousel () {
    const options = {
      margin: 15,
      items: this.slideItems,
      responsiveClass: true,
      responsive: {
        1311: this.setOwlParams(6),
        0: this.setOwlParams(4),
      },
      mouseDrag: false,
      itemElement: 'figure',
      dots: false,
      autoHeight: false,
    }
    /**
     * Если существует блок слева (например стр. поиска) то меняем кол-во отображаемых карточек
     */
    if ($('.reducer_col').length || this.isNarrowCarousel) {
      options.responsive = {
        1311: this.setOwlParams(5),
        1200: this.setOwlParams(4),
        0: this.setOwlParams(3),
      }
    }

    /*
     * Рекомендации в корзине:
     * Отображаем цены, только после получения актуальных
     * изначально скрыты в цсс
     */
    if (window.location.pathname === '/cabinet/cart/') {
      this.$el.find('.price-block').css('opacity', '1')
    }
    this.$el.addClass('owl-carousel')

    // Для работы нескольких экземпляров карусели на одной странице необходимо установить им id
    this.$el.attr('id', generateUniqId('recommendations-carousel'))
    this.$el
      .owlCarousel({ ...options, ...this.carouselOptions })
      .on('changed.owl.carousel', this.refreshElementsInViews.bind(this))
  }

  /**
   * Обновляет элементы
   */
  refreshElementsInViews () {
    const elementsLength = this.$(this.itemSelector).length
    if (this.elementsLength !== elementsLength && !isMobile) {
      this.elementsLength = elementsLength
      this.childViews.recommendationsItemViews.forEach(recommendationsView => {
        const sid = recommendationsView.sid
        recommendationsView.refreshElement(this.$(`.recommendations-item[data-sid=${sid}]`))
      })
    }
  }

  /**
   * Возвращает объект с параметрами для responsive в owl-карусели
   * @param {number} count Количество item-ов
   * @returns {Object} Объект с параметрами
   */
  setOwlParams (count) {
    const hideItemsCount = this.countItems - count
    const isItemsMoreCount = this.countItems > count
    return {
      items: count,
      loop: isItemsMoreCount,
      nav: isItemsMoreCount,
      slideBy: hideItemsCount < this.slideBy && hideItemsCount > 0 ? hideItemsCount : this.slideBy,
    }
  }
}
